export default [
  {
    heading: "Balustraden",
    text:
      "Alle Balustraden wurden von uns nach den Spezifikationen des Architekten gefertigt",
    img: "https://picsum.photos/500/500/?random&t=0"
  },
  {
    heading: "Türeinfassungen",
    text:
      "Auch diese Türeinfassungen wurden individuell für genau dieses Bauprojekt abgestimmt und von uns gefertigt. User Hauseigener Formenbau erlaubt uns diese Vorgehensweise.",
    img: "https://picsum.photos/500/500/?random&t=1"
  },
  {
    heading: "Gesimse",
    text:
      "Wir bieten neben Säulen und Balustraden auch noch die Maßfertigung von Fassadenelementen aus Beton an.",
    img: "https://picsum.photos/500/500/?random&t=3"
  }
];



// WEBPACK FOOTER //
// ./src/vue/slides.js